import Header from 'components/Header'
import React, { PropTypes } from 'react'
import LoadingIndicator from 'components/LoadingIndicator'
import {version} from 'shared/constants'

const App = ({children}, {logout, loading, user}) => {
  if (user.authenticating) return null

  return (
    <section className='container'>
      <section className='row'>
        <Header logout={logout} />
      </section>
      <section className='row'>
        <section className='col-xs-1-1'>
          {loading ? <LoadingIndicator/> : ''}
          {children}
        </section>
      </section>
      <footer className='row' style={{margin: '2rem 0 1rem'}}>
        <div className='col-xs-1-1'>
          <small>Made with <i className='fa fa-heart' /> by <a href='http://wide-eyes.it'>Wide Eyes</a> {version} <a target='_blank' href='/changelog'> changelog</a></small>
        </div>
      </footer>
    </section>
  )
}

App.propTypes = {
  children: PropTypes.element
}

App.contextTypes = {
  user: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
}

module.exports = App



// WEBPACK FOOTER //
// ./src/components/App/index.js